var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-title',[_c('v-col',[_c('v-card',{staticClass:"py-2 mx-auto my-n12 primary",attrs:{"raised":""}},[_c('v-card-title',[_c('v-row',{staticClass:"white--text",attrs:{"justify":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.title))])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }